import * as React from 'react';
import { GetServerSideProps } from 'next';
import MainPage from 'components/night-in';
import { getGeoCountry } from 'lib/get-geo-country';

type Props = {
    geoIpCountry: string | null;
};

const NightInPage: React.FC<Props> = function ({ geoIpCountry }) {
    return <MainPage geoIpCountry={geoIpCountry} />;
};

export default NightInPage;

export const getServerSideProps: GetServerSideProps<Props> = async function ({ req }) {
    return {
        props: {
            geoIpCountry: getGeoCountry(req),
        },
    };
};
